//#region Imports

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authenticatedRoute, unAuthenticatedRoute } from './routes/auth-routes.config';

//#endregion

const routes: Routes = [
  { path: '', redirectTo: 'main/inicio', pathMatch: 'full' },
  { path: 'main', loadChildren: () => import('./pages/main/main.module').then(m => m.MainModule), ...authenticatedRoute },
  { path: 'login', redirectTo: 'entrar' },
  { path: 'entrar', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule), ...unAuthenticatedRoute },
  { path: 'oauth2', loadChildren: () => import('./pages/oauth/oauth.module').then(m => m.OauthModule), ...unAuthenticatedRoute },
  { path: 'register', redirectTo: 'registrar' },
  { path: 'registrar', loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule), ...unAuthenticatedRoute },
  { path: '**', redirectTo: 'main/inicio' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
      relativeLinkResolution: 'legacy',
      anchorScrolling: "enabled",
      onSameUrlNavigation: "reload",
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
